import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonComponent } from '@shared/components/button/button.component';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { EpochDateTimePipe } from '@shared/pipes/epoch-datetime.pipe';
import { LoadingProvider } from '@shared/providers/loading.provider';
import { saveTextFile } from '@shared/util/fileUtil';
import { arrayIsEmpty } from '@shared/util/listUtil';
import { isNotBlank } from '@shared/util/stringUtils';
import { JsonEditorOptions, NgJsonEditorModule } from 'ang-jsoneditor';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MessageService } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { UserService } from '../../../shared/services/user.service';
import { User } from '@shared/interfaces/user';
import { UserFilter } from '@shared/interfaces/userFilter';

@Component({
  selector: 'app-user-admin',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ReactiveFormsModule,
    DropdownModule,
    InputTextModule,
    NgxMaskDirective, 
    NgxMaskPipe,
    ToastModule,
    ButtonComponent,
    ModalComponent,
    NgJsonEditorModule,
    EpochDateTimePipe
  ],
  providers: [provideNgxMask(), MessageService],
  templateUrl: './user-admin.component.html',
  styleUrl: './user-admin.component.scss'
})
export class UserAdminComponent {
  @ViewChild('viewModal') viewModal!: ModalComponent; 
  public editorOptions: JsonEditorOptions;
  selected: User[] = [];
  records: User[] = [];
  recordSelected: User | undefined;
  recordStatusList = ["active", "deleted", "disabled"];
  totalRecords: number = 0;
  loading: boolean = false;
  public form: FormGroup = this.fb.group({
    rut: [''],
    fullName: [''],
    recordStatus: ['active'],
  });

  constructor(private router: Router, 
    private route: ActivatedRoute,
    private fb: FormBuilder, 
    private messageService: MessageService,
    private loadingProvider: LoadingProvider,
    private userService: UserService) {
      this.editorOptions = new JsonEditorOptions()
      this.editorOptions.modes = ['code', 'text', 'tree', 'view']; // set all allowed modes
      this.editorOptions.mode = 'code'; //set only one mode
  }

  onSearch(params: TableLazyLoadEvent){
    this.loading = true;
    let filter = this.form.value as UserFilter;
    this.userService.pagedFindUser({
      filters: filter,
      first: params.first ?? 0,
      rows: params.rows ?? 10
    }).subscribe((resp) => {
      this.records = resp.list;
      this.totalRecords = resp.total;
      this.loading = false;
      this.selected = [];
    });
  }

  deleteBase(filter: UserFilter){
    this.loadingProvider.show();
    this.userService.deleteByGenerator(filter).subscribe({
      next: (resp) => {
        let ids = isNotBlank(filter.rut) ? filter.rut : filter.ruts?.join(',');
        this.loadingProvider.hide();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: `eliminado(s) ${ids}` });
        this.selected = [];
        this.onSearch({});
      },
      error: (err) => {
        this.loadingProvider.hide();
        let msg = err.error?.message || 'Ocurrió un error';
        console.log(msg);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
      }
    });
  }

  deleteSelected(){
    if (!arrayIsEmpty(this.selected)){
      let ruts: string[] = this.selected.map(item => item.rut!);
      this.deleteBase({
        ruts
      });
    }
  }

  delete(user: User){
    this.deleteBase({
      rut: user.rut
    });
  }

  view(user: User){
    this.recordSelected = user;
    this.viewModal.openModal();
  }

  download(user: User){
    saveTextFile(JSON.stringify(user, null, 2), `${user.rut}.json`);
  }
}
